import {VGLawCookie} from "vglawcookie";

window.Vegas = {
	init: function () {
		this.parallaxMouse();
		this.header();
		this.carousel();
		this.clone();
		this.scroll();
		this.popup();
		this.countdown();
		this.otherPlugins();
		this.forms();
		this.mobile();
	},

	parallaxMouse: function () {
		function parallaxMouse() {
			if ($('#parallax').length) {
				let scene = document.getElementById('parallax');
				new Parallax(scene);
			}
		}

		parallaxMouse();
	},

	header: function () {

	},

	clone: function () {
		let menu = $('.main-menu'),
			nav = menu.find('ul'),
			navigation = nav.clone();
		
		$('.navigation').append(navigation);
		
	},

	scroll: function () {
		let srclTop = $(window).scrollTop();
		stickyTop(srclTop);

		$(window).scroll(function () {
			let scrollTop = $(this).scrollTop();

			stickyTop(scrollTop);
		});

		function stickyTop(scrollTop) {
			if (scrollTop > 185) {
				$('header').addClass('sticky');
				$('.header-top-social').removeClass('col-lg-3').addClass('col-lg-2');
			} else {
				$('header').removeClass('sticky');
				$('.header-top-social').removeClass('col-lg-2').addClass('col-lg-3');
			}
		}
	},

	carousel: function () {
		let $owl = $('.owl-carousel');

		if ($owl.length) {
			$owl.each(function () {
				let $self = $(this);

				let items = $self.data('items') || 1,
					loop = $self.data('loop') || false,
					autoplay = $self.data('autoplay') || false,
					autoplayTimeout = $self.data('autoplayTimeout') || 7000,
					dots = $self.data('dots') || false,
					nav = $self.data('nav') || false,
					margin = $self.data('margin') || 0,
					stagePadding = $self.data('stagePadding') || 0,
					animateOut = $self.attr('data-animateOut') || false,
					animateIn = $self.attr('data-animateIn') || false,
					smartSpeed = $self.data('smartSpeed') || 500,
					responsive = {
						1200 : {
							items: items
						}
					};

				// responsive
				let xs = $self.data('xs') || false; // 0px
				if (xs) {
					let params = {
						0 : xs
					};
					
					responsive = $.extend(responsive, params);
				}
				
				let sm = $self.data('sm') || false; // 480px
				if (sm) {
					let params = {
						480 : sm
					};
					
					responsive = $.extend(responsive, params);
				}
				
				let md = $self.data('md') || false; // 768px
				if (md) {
					let params = {
						768 : md
					};
					
					responsive = $.extend(responsive, params);
				}
				
				let lg = $self.data('lg') || false; // 992
				if (lg) {
					let params = {
						992 : lg
					};
					
					responsive = $.extend(responsive, params);
				}
				
				let xl = $self.data('xl') || false; // 992
				if (xl) {
					let params = {
						1200 : xl
					};
					
					responsive = $.extend(responsive, params);
				}
				
				// animation
				let animatedIn = {}, animatedOut = {};

				if (animateIn) {
					animatedIn = {
						animateIn: animateIn
					}
				}
				if (animateOut) {
					animatedOut = {
						animateOut: animateOut
					}
				}

				// navigation
				let navigation = {}, navText = {};
				if (nav) {

					switch (nav) {
						case 'chevron-icon':
							navText = {
								navText: ["<span class='vg-owl-chevron'><i class='fa fa-chevron-left'></i></span>", "<span class='vg-owl-chevron'><i class='fa fa-chevron-right'></i></span>"],
							};
							break;
						case 'chevron-dark':
							navText = {
								navText: ["<span class='vg-owl-chevron vg-owl-chevron-dark vg-owl-chevron-left'></span>", "<span class='vg-owl-chevron vg-owl-chevron-dark vg-owl-chevron-right'></span>"],
							};
							break;
						default:
							navText = {
								navText: ["<i class='fal fa-chevron-left'></i>", "<i class='fal fa-chevron-right'></i>"],
							};
					}

					navigation = $.extend({
						nav: true
					}, navText);
				}

				let options = {
					items: items,
					loop: loop,
					autoplay: autoplay,
					autoplayTimeout: autoplayTimeout,
					margin: margin,
					stagePadding: stagePadding,
					dots: dots,
					smartSpeed: smartSpeed,
					responsive: responsive
				};

				options = $.extend(options, animatedOut, animatedIn, navigation);
				
				$self.owlCarousel(options);
			});
		}
	},

	forms: function () {
		$('.form-ajax').vegasFormSender({
			beforeSend: function (form) {
				let $btn = form.find('[type=submit]');
				Vegas.Alerts.beforeSend($btn);
			},
			success: function (data, form) {
				Vegas.Alerts.success(data.msg, form);
			},
			error: function (msg, form) {
				Vegas.Alerts.error(msg);
			},
			validate: function (form, errors) {
				Vegas.Alerts.validate(errors);
			}
		});
	},

	Alerts: {
		success: function (msg, form) {
			let $modal = $('#modal-success');
			let $btn = form.find('[type=submit]');
			
			msg = msg || $btn.data('success');
			
			$('.modal').modal('hide');
			
			$modal.find('.msg').text(msg);
			$modal.modal('show');
			
			$btn.attr('disabled', 'false').text($btn.data('text'));
		},
		error: function (msg) {
			let $modal = $('#modal-error');
			
			$('.modal').modal('hide');
			
			$modal.find('.msg').text(msg);
			$modal.modal('show');
		},
		validate: function (errors) {
			$.each(errors, function () {
				let $self = $(this);
				
				$self.addClass('error');
			});
		},
		beforeSend: function ($btn) {
			$btn.attr('disabled', 'true').text($btn.data('text-send'));
		}
	},

	popup: function () {
		$('.modal').on('shown.bs.modal', function (e) {
			$(this).find('.close').css('opacity', 1);
		});
		
		/* magnificPopup img view */
		$('.popup-image').magnificPopup({
			type: 'image',
			gallery: {
				enabled: true
			}
		});
	},

	countdown: function () {
		$('[data-countdown]').each(function () {
			var $this = $(this), finalDate = $(this).data('countdown');
			$this.countdown(finalDate, function (event) {
				$this.html(event.strftime(
					'<div class="time-count">%D<span>дней</span></div>' +
					'<div class="time-count">%H<span>часов</span></div>' +
					'<div class="time-count">%M<span>минут</span></div>' +
					'<div class="time-count">%S<span>секунд</span></div>'));
			});
		});
	},

	otherPlugins: function () {
		// Tooltip
		$('[data-toggle="tooltip"]').tooltip();

		// niceSelect;
		$(".selected,.selected-second,.select-third").niceSelect();

		// Mask
		$('.input-mask-phone').inputmask('8 (999) 999-99-99', {"clearIncomplete": true}).on('paste', function (e) {
			$(this).val(normalize_phone_inputmask(e.originalEvent.clipboardData.getData('text')));
			return false;
		}).on('change', function () {
			$(this).val(normalize_phone_inputmask($(this).val()));
		});
		
		// Scrollbars
		$('[class^="scroll-"], [class*="scroll-"]').overlayScrollbars({});
		
		//
		let $grid = $('.gallery-albums');
		$($grid).imagesLoaded(function () {
			$grid.find('.row').masonry({
				itemSelector: '.col-md-4.col-12',
				layoutMode: 'sloppyMasonry',
				resizable: false, // disable normal resizing
				// set columnWidth to a percentage of container width
				masonry: { }
			});
		});
		
		//
		let $gridCat = $('.gridCat');
		$($gridCat).imagesLoaded(function () {
			$gridCat.find('.row').masonry({
				itemSelector: '.col-md-3',
				layoutMode: 'sloppyMasonry',
				resizable: false, // disable normal resizing
				// set columnWidth to a percentage of container width
				masonry: { }
			});
		});
		
		// vegas menu
		let $vgnav = $('.vg-nav');
		$vgnav.vegasMenu();
		
		let $vgnav_li = $vgnav.find('li.dropdown-mega');
		$vgnav_li.each(function (i) {
			let $self = $(this),
				width = $self.width() / 2,
				offset = $self.position().left + width;
			
			$('body').append('<style>.dropdown-mega:nth-child(' + (i + 1) + ') .dropdown-mega-container:after, .dropdown-mega:nth-child(' + (i + 1) + ') .dropdown-mega-container:before {left: ' + offset +'px}</style>')
		});

		new VGLawCookie({
			enableLinkMore: true,
		});
	},
	
	mobile: function () {
		$('[data-toggle=mCategory]').on('click', function () {
			let $self = $(this),
				$li = $self.closest('li');
			
			$li.toggleClass('show');
			
			if($self.data('target')) {
				let $subSection = $('.mobile-sub-categories');
				
				$subSection.find('.subCategories').removeClass('show').slideUp();
				$subSection.find($self.data('target')).addClass('show').slideDown();
			}
			
			return false;
		});
		
		$('[data-toggle=mCategoryChild]').on('click', function () {
			let $self = $(this),
				$section = $self.closest('.subCategories');
			
			$self.closest('li').find('> ul').slideToggle();
			
			return false;
		});
		
		
		$('[data-toggle=mSubCategoryClose]').on('click', function () {
			let $subSection = $('.mobile-sub-categories');
			
			$subSection.find('.subCategories').removeClass('show').slideUp();
			
			return false;
		});
		
		$('[data-toggle=mCategoryBack]').on('click', function () {
			let $self = $(this),
				$li = $self.closest('ul').parent('li');
			
			$li.removeClass('show');
			
			return false;
		});
		
		$('[data-toggle=mSearch]').on('click', function () {
			let $self = $(this),
				$container = $self.closest('.header-mobile-top').find('.header-search'),
				$vgnav = $('.vg-nav');
			
			$container.toggleClass('show');
			$('.vg-nav-sidebar, .vg-nav-overlay, .vg-nav-hamburger').removeClass('show');
			
			if($container.hasClass('show')) {
				$vgnav.css('z-index', 0);
				$container.find('input').focus();
			} else {
				$vgnav.css('z-index', 999);
				$container.find('input').blur();
			}
			
			return false;
		});
	}
};